import React from 'react';
import * as Styles from './Paragraph.Styles';

const ParagraphHeader = ({ children, danger }) => {
  return (
    <Styles.StyledParagraphHeader className={danger ? 'danger' : null}>
      {children}
    </Styles.StyledParagraphHeader>
  );
};

export default ParagraphHeader;
